import { render, staticRenderFns } from "./Thumbnail.vue?vue&type=template&id=6786771a&scoped=true&"
import script from "./Thumbnail.vue?vue&type=script&lang=js&"
export * from "./Thumbnail.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/thumbnail.css?vue&type=style&index=0&id=6786771a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6786771a",
  null
  
)

export default component.exports